// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1coVO","index":"styles_index__GaDjz"};